export const DATE_PERIOD_FILTER_OPTIONS = [
  { value: 'today', label: 'Today' },
  { value: '7days', label: 'Last 7 days' },
  { value: '30days', label: 'Last 30 days' },
  { value: '1year', label: 'Last 1 year' },
] as const;

export type DatePeriodValue =
  (typeof DATE_PERIOD_FILTER_OPTIONS)[number]['value'];
